<template>
  <v-select v-model="selected_role" :items="roles" label="Roles" dense solo @input="change_role()"> </v-select>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
  data: () => ({
    selected_role: "Admin"
  }),
  computed: {
    ...mapActions(["fetchPositions"]),
    ...mapState({
      items: (state) => state.positions.positions,
    }),
    roles() {
      return this.items.map((x) => {
        return x.name;
      });
    },
  },
  methods: {
    change_role(){
      console.log(this.selected_role)
      this.$emit('input', this.selected_role);
    }
  },
  unmounted:function(){
    this.password = ""
    this.selected_role = "Admin"
  },
  created: () => {},
};
</script>
